import type { IconData } from '@stacksjs/iconify-core'

export const xCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m348.071 141.302l-87.763 87.763l-87.763-87.763l-22.628 22.627l87.764 87.763l-87.764 87.764l22.628 22.627l87.763-87.763l87.763 87.763l22.628-22.627l-87.764-87.764l87.764-87.763z\"/><path fill=\"currentColor\" d=\"M425.706 86.294A240 240 0 0 0 86.294 425.706A240 240 0 0 0 425.706 86.294M256 464c-114.691 0-208-93.309-208-208S141.309 48 256 48s208 93.309 208 208s-93.309 208-208 208\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default xCircle
